import type { RouteObject } from "react-router-dom";
import type { AppRouteProps } from "../types";

export const renderRoute = (route: AppRouteProps): RouteObject => ({
  path: route.path,
  element: route.element,
  children: route.children?.map(renderRoute),
});
